// extracted by mini-css-extract-plugin
export default {"root":"styles_root__V-zY-","title":"styles_title__ZFKgK","value":"styles_value__ayd3F"};